export default __webpack_public_path__ + "static/cashflow_new_0-1ada1ec019aaf27bf25fe5765264f827.jpg";